import React from 'react';
import UserService from '../services/user';



class AuthorizationCheck extends React.Component {

    constructor(props) {
        super(props);

        this.userService = new UserService();

        this.state = {
            authorized: false
        };


    }

    componentDidMount() {

        this.isAuthorized();
    }

    isAuthorized = async () => {

        try {

            const response = await this.userService.isAuthorized(this.props.accessLevel);

            if (!response.ok) {



                window.location.href = '/dashboard'
            }

            const authData = await response.json();

            

            this.props.userRole(authData.role);

            //this.props.userGroup(authData.group);

        } catch (error) {

            console.log(error);
             window.location.href = '/dashboard'
        }




        /*response.then(function(res) {

            if(!res.ok){

                

                window.location.href = '/dashboard'
            }

            

            
            
            return res.json();
            
        }).then( authData => this.props.userRole(authData.role))
        .catch(error => window.location.href = '/dashboard')*/








    }


    render() {



        return '';

    }
}

export default AuthorizationCheck;